var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"performer-twitter-item"},[_c('Timeline',{attrs:{"id":_vm.accountId,"sourceType":"profile"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }